import RegisterEmpresaComponent from "../components/RegisterEmpresa/RegisterEmpresa";
import Navbar from "../components/Navbar/Navbar";

export default function RegisterEmpresa() {
  return (
    <div>
      <Navbar />

      <RegisterEmpresaComponent />
    </div>
  );
}
